import { render, staticRenderFns } from "./UserListSearchBox.vue?vue&type=template&id=2025c213&scoped=true"
import script from "./UserListSearchBox.vue?vue&type=script&lang=js"
export * from "./UserListSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025c213",
  null
  
)

export default component.exports